import React, { useEffect, useState } from "react";
import "./Loader.css";

const Loader = ({ onFinish }) => {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    let seen = false;
    try {
      seen = sessionStorage.getItem("seenLoader") === "1";
      sessionStorage.setItem("seenLoader", "1");
    } catch (e) {
      // storage can be blocked; fall back to the full intro
    }
    const t1 = setTimeout(() => setHide(true), seen ? 150 : 1100);
    const t2 = setTimeout(onFinish, seen ? 500 : 1700);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [onFinish]);

  return (
    <div className={`loader ${hide ? "loader-hide" : ""}`} role="status" aria-label="Loading">
      <div className="loader-content">
        <h1 className="loader-logo">
          Kiran<span>.</span>
        </h1>
        <div className="loader-bar">
          <i />
        </div>
      </div>
    </div>
  );
};

export default Loader;
